import Component from "../component";
import { AssetFeatureResponse, AssetResponse } from "../../types/stores";
import {
    formatDateJO,
    getOpeningWeekList,
    getReadableAddress,
    getServicesList,
    countDays
} from "../../helpers/stores";
import { getLocale, getLabel } from "../../helpers/locale";

export interface IStoreDetailsComponent {
    store?: AssetFeatureResponse;
}

export enum StoreDetailsComponentEvents {
    DIRECTIONS_SHOW = "directions_show",
    BACK = "back",
}
interface Event {
    name: string,
    rounds: Array<Round>
}
interface Round {
    dateTime: string,
    name: string,
    medal: boolean,
    gender: string,
    desc: string,
}
interface GroupedRounds {
    [date: string]: Round[];
}
export default class StoreDetailsComponent extends Component<IStoreDetailsComponent> {
    init(): void {
        this.$element = document.createElement("div");
        this.$target.appendChild(this.$element);
    }

    render(): void {
        if (this.state && this.$element) {
            if (this.state.store) {
                const properties = this.state.store.properties;
                const htmlElements: HTMLElement[] = [];
                const $backBtn: HTMLDivElement = this.getBackButton();
                const $storeDetailsHeader: HTMLDivElement = this.getDetailsHeader(properties);
                const $storeDetailsActions: HTMLDivElement = this.getActionsButtons(properties);
                const $eventDetails: HTMLDivElement = this.getEvents(properties);
                const $storeDetails: HTMLDivElement = document.createElement("div");
                $storeDetails.className = "detailsStore";
                $storeDetails.innerHTML = `
                             ${properties.weekly_opening ? `<div class="detailsStore__content detailsStore__listItems"><div class="detailsStore__headerList">${getLocale().time.openingHoursTitle}</div>${getOpeningWeekList(properties.weekly_opening)}</div>` : ""}
                             ${properties.tags?.length ? `<div class="detailsStore__content detailsStore__listItems"><div class="detailsStore__headerList">${getLocale().filtering.servicesTitle}</div>${getServicesList(properties.tags)}</div>` : ""}`;
                htmlElements.push($backBtn, $storeDetailsHeader, $storeDetailsActions, $eventDetails);
                this.$target.replaceChildren(...htmlElements);
                this.updateEventCountdown(properties.user_properties?.events as Array<Event>);
            }
        }
    }

    getDetailsHeader(properties: AssetResponse): HTMLDivElement {
        const $storeDetailsHeader: HTMLDivElement = document.createElement("div");
        const typeOfSite = properties.types?.length ? properties.types.join(" ,") : '';
        const name = properties.name.replace('Stage', getLocale().stores.name.Stage);
        $storeDetailsHeader.className = "detailsStore";
        $storeDetailsHeader.innerHTML = `
                             <div class="detailsStore__thumbnail"><div class="detailsStore__thumbnailImg" style="background-image: url(${properties.user_properties?.imageURL})"></div></div>
                             <div class="detailsStore__content detailsStore__name">${name}</div>
                             ${properties.types?.length ? `<div class="detailsStore__content detailsStore__types">${getLabel(getLocale().stores.types, typeOfSite)}</div>` : ""}                             
                             ${properties.address ? `<div class="detailsStore__content detailsStore__address">${getReadableAddress(properties.address)}</div>` : ""}
                             ${properties.user_properties?.events ? `<div class="detailsStore__content detailsStore__event">Next event in</div>` : ""}`;

        return $storeDetailsHeader;
    }

    getActionsButtons(properties: AssetResponse): HTMLDivElement {
        const $storeDetailsActions: HTMLDivElement = document.createElement("div");
        $storeDetailsActions.className = "detailsStore__content detailsStore__actions";

        const $directionsBtn: HTMLButtonElement = document.createElement("button");
        $directionsBtn.className = "button";
        $directionsBtn.addEventListener("click", () => this.emit(StoreDetailsComponentEvents.DIRECTIONS_SHOW, this.state.store));
        $directionsBtn.innerHTML = `<div class="buttonIcon directionsButton"></div><span>${getLocale().stores.cta.directions}</span>`;
        $storeDetailsActions.appendChild($directionsBtn)

        if (properties.contact?.phone) {
            const $phoneBtn: HTMLButtonElement = document.createElement("button");
            $phoneBtn.className = "button";
            $phoneBtn.innerHTML = `<div class="buttonIcon phoneButton"></div><span>${getLocale().stores.cta.call}</span>`;
            $phoneBtn.addEventListener("click", () => {
                window.open(`tel:${properties.contact?.phone}`, '_self');
            });
            $storeDetailsActions.appendChild($phoneBtn)
        }
        if (properties.contact?.website) {
            const $websiteBtn: HTMLButtonElement = document.createElement("button");
            $websiteBtn.className = "button";
            $websiteBtn.innerHTML = `<div class="buttonIcon websiteButton"></div><span>${getLocale().stores.cta.website}</span>`;
            $websiteBtn.addEventListener("click", () => {
                window.open(`${properties.contact?.website}`, '_blank');
            });
            $storeDetailsActions.appendChild($websiteBtn)
        }

        return $storeDetailsActions;
    }

    getBackButton(): HTMLDivElement {
        const $headerContainer: HTMLDivElement = document.createElement("div");
        $headerContainer.className = "detailsStore__header"
        const $backBtn: HTMLButtonElement = document.createElement("button");
        $backBtn.className = "backButton";
        $backBtn.addEventListener("click", () => this.emit(StoreDetailsComponentEvents.BACK));
        $backBtn.innerHTML = `<div class="backButton__icon"></div>`;
        $headerContainer.innerHTML = `<div class="detailsStore__headerTitle"></div>`
        $headerContainer.appendChild($backBtn)
        return $headerContainer;
    }
    getEvents(properties: AssetResponse): HTMLDivElement {
        const $eventsElements: HTMLDivElement = document.createElement("div");
        $eventsElements.className = "eventsDetail";
        const events = properties.user_properties?.events as Array<Event>;
        if (events && events.length > 0) {
            events.forEach((event) => {
                const $eventElement = document.createElement("div");
                $eventElement.className = "collapsible";
                $eventElement.classList.add("sport");
                $eventElement.innerHTML = `<span class="collapsibleTitle">${event.name}</span><div class="collapsibleIcon"></div>`
                $eventElement.addEventListener("click", () => this.toggleActive($eventElement));
                $eventsElements.appendChild($eventElement)
                const matchesByDate: GroupedRounds = this.groupEventRoundsByDate(event.rounds);
                if (matchesByDate && matchesByDate) {
                    const $dateWiseContainer: HTMLDivElement = document.createElement("div");
                    $dateWiseContainer.className = "collapsibleSchedule";
                    for (const [date, events] of Object.entries(matchesByDate)) {
                        const dayDiv = document.createElement('div');
                        dayDiv.classList.add('day');

                        const dayHeader = document.createElement('h4');
                        dayHeader.textContent = date;
                        dayDiv.appendChild(dayHeader);

                        const ul = document.createElement('ul');

                        events.forEach((round) => {
                            const li = document.createElement('li');

                            const eventSpan = document.createElement('span');
                            eventSpan.classList.add('event');
                            eventSpan.textContent = round.name;
                            li.appendChild(eventSpan);

                            if(round.medal){
                                const medalElem = document.createElement('div');
                                medalElem.className = "iconMedal";
                                li.appendChild(medalElem);
                            }                          

                            const genderSpan = document.createElement('span');
                            genderSpan.classList.add('time');
                            genderSpan.textContent = round.gender === 'Not Applicable' ? 'NA' : round.gender;
                            li.appendChild(genderSpan);

                            const timeSpan = document.createElement('span');
                            timeSpan.classList.add('time');
                            timeSpan.textContent = new Date(round.dateTime).toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' })
                            li.appendChild(timeSpan);

                            ul.appendChild(li);
                        });

                        dayDiv.appendChild(ul);
                        $dateWiseContainer.appendChild(dayDiv);
                        $eventsElements.appendChild($dateWiseContainer);
                    }
                }
            });
        }
        return $eventsElements;
    }
    groupEventRoundsByDate(rounds: Array<Round>): GroupedRounds {
        return rounds.reduce((acc, round) => {
            const date = formatDateJO(round.dateTime);
            if (!acc[date]) {
                acc[date] = [];
            }
            acc[date].push(round);
            return acc;
        }, {} as GroupedRounds);
    }
    updateEventCountdown_old(events: Array<Event>): void {
        const dateTimesNested = events.map(event => event.rounds.map(round => round.dateTime));
        const dateTimes = dateTimesNested.reduce((acc, val) => acc.concat(val), []);
        const dates = dateTimes.map(dateTime => new Date(dateTime));
        const earliestDateTimestamp = Math.min(...dates.map(date => date.getTime()));
        const earliestDate = new Date(earliestDateTimestamp);
        const eventStartText = countDays(earliestDate.toString());
        const $countdownElement = document.getElementsByClassName("detailsStore__event");
        if($countdownElement && $countdownElement.length > 0){
            $countdownElement[0].innerHTML = eventStartText;
        }
    }
    updateEventCountdown(events: Array<Event>): void {
        const dateTimesNested = events.map(event => event.rounds.map(round => round.dateTime));
        const dateTimes = dateTimesNested.reduce((acc, val) => acc.concat(val), []);
        const dates = dateTimes.map(dateTime => new Date(dateTime));
        const now = new Date();
        const futureDates = dates.filter(date => {
            const isFutureDate = date.getTime() > now.getTime();
            // const isToday = date.toDateString() === now.toDateString();
            const isToday = date.toDateString() === now.toDateString() && date.getTime() >= now.getTime();
            return isFutureDate || isToday;
          });
        if(futureDates.length > 0){
            const earliestDateTimestamp = Math.min(...futureDates.map(date => date.getTime()));
            const earliestDate = new Date(earliestDateTimestamp);
            const eventStartText = countDays(earliestDate.toString());
            const $countdownElement = document.getElementsByClassName("detailsStore__event");
            if($countdownElement && $countdownElement.length > 0){
                $countdownElement[0].innerHTML = eventStartText;
            }
        }
        
    }
    toggleActive(element: HTMLElement): void {
        element.classList.toggle("active");
        const content = element.nextElementSibling as HTMLUListElement;
        if (content?.style.maxHeight && content?.style.maxHeight != "0px") {
            content.style.maxHeight = "0px";
        } else {
            content.style.maxHeight = content.scrollHeight + "px";
        }
    }
}
